export default __webpack_public_path__ + "static/media/font-bg.9e6efc67.svg";